var map = {
	"./cagayan-cert.webp": 1935,
	"./cert-bg.webp": 1936,
	"./isle-cert.webp": 1937,
	"./license-bg-cn.webp": 1938,
	"./license-bg-mobile-cn.webp": 1939,
	"./license-bg-mobile.webp": 1940,
	"./license-bg.webp": 1941,
	"./pagcor-cert.webp": 1942,
	"./page-bg.webp": 1943
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 879;